<ion-content>
	<ion-fab horizontal="end" vertical="top" slot="fixed">
		<ion-fab-button color="danger" (click)="close()">
			<ion-icon name="close"></ion-icon>
		</ion-fab-button>
	</ion-fab>
	<app-cached-image *ngIf="url" class="ds" [src]="url">
	</app-cached-image>
</ion-content>